<template>
    <!-- 1) Einbinden unseres vorhandenen ContentTemplate -->
    <ContentTemplate
      :mainHeading="mainHeading"
      :subHeading="subHeading"
      :sections="sections"
      :showContentNav="true"
    />
</template>

<script>
import ContentTemplate from '@/components/ContentTemplate.vue';

export default {
  name: 'ImpressumContent',
  components: {
    ContentTemplate
  },
  data() {
    return {
      mainHeading: "Legal Disclosure",
      subHeading: "Information according to §5 E-Commerce Act",
      sections: [
        {
          title: "Media Owner and Publisher",
          text: `
            <p>
              Salzburg University of Applied Sciences<br>
              <a href="https://www.alpine-space.eu/project/cefoodcycle/" target="_blank">Interreg Alpine Space CEFoodCycle</a><br>
              Urstein Süd 1<br>
              A-5412 Puch/Salzburg<br>
              Austria
            </p>
          `,
          ref: "medieninhaber",
          subsections: [
            {
              title: "Contact",
              ref: "kontakt",
              text: `
                <p>
                  Phone: +43 50 2211 - [Project extension - to be completed]<br>
                  Email: [Project email address - to be completed]<br>
                  Web: <a href="https://www.fh-salzburg.ac.at" target="_blank">https://www.fh-salzburg.ac.at</a>
                </p>
              `
            }
          ]
        },
        {
          title: "Legal Information",
          text: `
            <ul>
              <li>VAT ID: ATU 44554503</li>
              <li>Company Registration Number: FN 166054y</li>
              <li>Commercial Court: Regional Court Salzburg</li>
              <li>Content and editorial responsibility: [Name of project leader]</li>
            </ul>
          `,
          ref: "rechtliches"
        },
        {
          title: "Members of the Supervisory Board",
          text: `
            <p>AK-Dir. Mag.a Cornelia Schmidjell-Esterbauer<br>
            Mag.a Hilla Lindhuber<br>
            WK-Vice President Mag.a Marianne Kusejko<br>
            WK-Dir. Dr. Manfred Pammer<br>
            Dr.in Maria Ziller, LLM<br>
            Mag. Walter Haas<br>
            FH-Prof. DIin Brigitte Jellinek, MSc (Chairwoman of the Works Council, appointed by the Works Council)<br>
            Dkff. Susanne Steppat (appointed by the Works Council)<br>
            Markus Hussl (appointed by the Works Council)</p>
          `,
          ref: "aufsichtsrat"
        },
        {
          title: "Ownership and Participation Structures",
          text: `
            <p>
              The Salzburg Chamber of Commerce, the Salzburg Chamber of Labor, and the State of Salzburg each hold one-third 
              of the shares in Salzburg University of Applied Sciences GmbH. 
              Voting rights are determined by the amount of capital contributions made.
            </p>
          `,
          ref: "beteiligungen"
        },
        {
          title: "Supervisory Authority",
          text: `
            <p>
              Agency for Quality Assurance and Accreditation Austria / Federal Ministry for Science and Research.<br>
              Salzburg University of Applied Sciences GmbH is a member of the Austrian University of Applied Sciences Conference.
            </p>
          `,
          ref: "aufsichtsbehoerde"
        },
      ],
    };
  },
  mounted() {
    // Sobald die Komponente gemountet ist, emitten wir 'sections',
    // damit ImpressumView das linke Menu aktualisieren kann.
    this.$emit('sections-content-updated', this.sections);
  }
};
</script>

<style scoped>
/* Falls du noch spezifische Styles brauchst */
</style>
